<app-whatsapp-button></app-whatsapp-button>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
            <h1>Esqueceu sua senha?</h1>
            <p>Não tem problema.<br>Informe o e-mail cadastrado e receba as orientações para criar uma nova senha.</p>
        </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center" [ng2-loading]="showSpinner">
        <div class="col-lg-6">

            <div class="row">
                <div class="col-12">
                    <div class="form-panel">
                        <form name="form" (ngSubmit)="f.form.valid && enviarEmail()" #f="ngForm">
                            <div class="form-group" [ngClass]="{ 'invalid': (email.invalid && email.touched) || (email.invalid && f.submitted)  }">
                                <label for="email"><h2><img src="assets/icons/mail.svg" alt="Ícone de e-mail"> E-mail</h2></label>
                                <input type="email" class="form-control" id="email" name="email" [(ngModel)]="model.email" #email="ngModel" required>
                            </div>

                            <div class="form-group center">
                                <re-captcha #rc1 (resolved)="resolved($event)" [siteKey]="reCaptchaKey"></re-captcha>
                            </div>

                            <button type="submit" class="btn btn-primary btn-block mb-3">Receber orientações por e-mail</button>
                        </form>
                    </div>
                </div>
                <button id="openModal" #openModal [hidden]="true" data-toggle="modal" data-target="#mail-modal"></button>
                <div class="col-12" *ngIf="sms">
                      <form name="form" (ngSubmit)="g.form.valid && enviarSMS()" #g="ngForm" class="form-panel">
                      <div class="form-group" [ngClass]="{ 'invalid': (cpf.invalid && cpf.touched) || (cpf.invalid && g.submitted)  }">
                        <label for="cpf"><h2><img src="assets/icons/iPhone.svg" alt="Ícone de telefone"> SMS</h2></label>
                        <p>Para receber o código por SMS, confirme o CPF cadastrado:</p>
                        <label for="cpf">CPF</label>
                        <input [textMask]="{mask: cpfmask}" placeholder="___.___.___-__" type="text" class="form-control" id="cpf" name="cpf" [(ngModel)]="model.cpf" #cpf="ngModel" required>
                      </div>

                      <div class="form-group center">
                        <re-captcha #rc2 (resolved)="resolved($event)" [siteKey]="reCaptchaKey"></re-captcha>
                      </div>

                        <button type="submit" class="btn btn-primary btn-block mb-3">Receber orientações por SMS</button>
                      </form>
                </div>
              <button id="openSMSModal" #openSMSModal [hidden]="true" data-toggle="modal" data-target="#sms-modal"></button>

                <!-- <div class="col-12">
                    <div class="form-panel">
                        <h2><img src="assets/icons/newspaper.svg" alt="Ícone de questionário"> Responder questionário</h2>

                        <p>Você também pode recuperar sua senha através do questionário, para confirmar sua identidade.
                        </p>

                        <p><a href="#" class="btn btn-block btn-primary">Responder questionário</a></p>
                    </div>
                </div> -->
            </div>


            <!-- Modal -->
            <div class="modal fade" id="mail-modal" tabindex="-1" role="dialog" aria-labelledby="mail-modal-lLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content" [ng2-loading]="showSpinnerReenvio">
                        <div class="modal-header">
                            <h2><img src="assets/icons/mail.svg" alt="Ícone de e-mail"> E-mail enviado</h2>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> <!-- /modal-header -->
                        <div class="modal-body">
                            <p>Uma mensagem foi enviada para o e-mail cadastrado. Acesse e clique no link para cadastrar uma nova senha.</p>

                            <div class="row mt-2">
                                <div class="col-12">
                                    <p class="caption gray">Não recebeu?</p>
                                </div>
                                <div class="col-6">
                                    <button type="button" (click)="enviarEmail(true)" class="btn btn-default btn-block">Reenviar</button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-block" data-dismiss="modal">Ok</button>
                                </div>
                            </div> <!-- /row -->
                        </div> <!-- /modal-body -->
                    </div> <!-- /modal-content -->
                </div> <!-- /modal-dialog -->
            </div> <!-- /modal -->

          <!-- Modal -->
          <div class="modal fade" id="sms-modal" tabindex="-1" role="dialog" aria-labelledby="sms-modal-lLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content" [ng2-loading]="showSpinnerReenvio">
                <div class="modal-header">
                  <h2><img src="assets/icons/iPhone.svg" alt="Ícone de telefone"> Enviar SMS</h2>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div> <!-- /modal-header -->
                <div class="modal-body">
                  <p>Confirme se deseja enviar um sms para <b>{{phone}}</b>.</p>
                  <div class="form-group center">
                    <re-captcha #rc3 (resolved)="resolved($event)" [siteKey]="reCaptchaKey"></re-captcha>
                  </div>
                  <div class="row mt-2">
                    <div class="col-6">
                      <button type="button" class="btn btn-default btn-block" data-dismiss="modal">Voltar</button>
                    </div>
                    <div class="col-6">
                      <button type="button" (click)="sendSMS()" class="btn btn-primary btn-block" data-dismiss="modal" [disabled]="!model.token || model.token == ''">Enviar</button>
                    </div>
                  </div> <!-- /row -->
                </div> <!-- /modal-body -->
              </div> <!-- /modal-content -->
            </div> <!-- /modal-dialog -->
          </div> <!-- /modal -->

            <!-- Modal -->
            <div class="modal fade" id="phone-modal" tabindex="-1" role="dialog" aria-labelledby="phone-modal-lLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2><img src="assets/icons/iPhone.svg" alt="Ícone de telefone"> Link enviado</h2>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> <!-- /modal-header -->
                        <div class="modal-body">
                            <p>Acesse seu e-mail e clique no link para validar seu cadastro.</p>

                            <div class="row mt-2">
                                <div class="col-12">
                                    <p class="caption gray">Não recebeu?</p>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-default btn-block">Reenviar</button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-block" data-dismiss="modal">Ok</button>
                                </div>
                            </div> <!-- /row -->
                        </div> <!-- /modal-body -->
                    </div> <!-- /modal-content -->
                </div> <!-- /modal-dialog -->
            </div> <!-- /modal -->

        </div> <!-- /form -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
        <div class="col-6">
            <a routerLink="/" class="btn btn-link">&lt; Voltar</a>
        </div>
    </div>
</div> <!-- /container -->
